import React from "react";
import { cn } from "lib/utils";

interface PageHeaderProps {
  title: React.ReactNode;
  /** Small label above the title, e.g. the settings section a page belongs to. */
  eyebrow?: React.ReactNode;
  description?: React.ReactNode;
  /** The page's main actions, shown on the right on wide screens and under the title on phones. */
  actions?: React.ReactNode;
  className?: string;
}

/** The heading every admin page opens with: title, optional context, and the page's main actions. */
export default function PageHeader({ title, eyebrow, description, actions, className }: PageHeaderProps) {
  return (
    <div className={cn("mb-6 flex flex-col gap-4 md:mb-8 md:flex-row md:items-end md:justify-between", className)}>
      <div className="min-w-0">
        {eyebrow && (
          <div className="mb-1.5 text-xs font-semibold uppercase tracking-wider text-default-500">{eyebrow}</div>
        )}
        <h1 className="font-display text-2xl font-semibold tracking-tight text-default-900 md:text-[28px] md:leading-tight">
          {title}
        </h1>
        {description && <p className="mt-1.5 max-w-2xl text-sm text-default-600">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
